import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { DataCacheService } from './data-cache.service';
import { ApiSleepSensorService } from './api-call-providers/api-sleep-sensor.service';
import { COOKIES_CONFIG } from './../configs/cookies.config';
import { Observable } from 'rxjs';


@Injectable()
export class SleepSensorService {

  // センサーリスト
  private sensorSource = new Subject<any>();
  sensors$ = this.sensorSource.asObservable();

  // センサーセット作成
  private createSource = new Subject<any>();
  create$ = this.createSource.asObservable();

  // センサー一括作成
  private createAllSource = new Subject<any>();
  createAll$ = this.createAllSource.asObservable();

  // センサーセット
  private setSource = new Subject<any>();
  set$ = this.setSource.asObservable();

  // センサー全更新
  private updateAllSource = new Subject<any>();
  updateAll$ = this.updateAllSource.asObservable();

  // センサーセット削除
  private deleteSource = new Subject<any>();
  delete$ = this.deleteSource.asObservable();

  constructor(
    private apiSleepSensorService: ApiSleepSensorService,
    private _dataCacheService: DataCacheService,
  ) {
  }

  async getSettingInfo() {
    this.apiSleepSensorService.isLoading = true;
    return this.apiSleepSensorService.getSettingInfo();
  }

  async load() {
    this.apiSleepSensorService.isLoading = true
    let _data = await this._dataCacheService.get(COOKIES_CONFIG.SENSORS_DATA)
    if (!_data.isExist()) {
      // キャッシュデータが古い or ない場合、データロード
      return this.fetch();
    }
    this.apiSleepSensorService.isLoading = false
    this.sensorSource.next(_data);
    return _data;
  }

  /**
   * APIを叩いて、患者情報を取得する
   * @param params
   */
  async fetch(isForce: boolean = false) {
    let res: any = await this.apiSleepSensorService.list()
    let data = { data: res.data }
    if (res.expired && !isForce) {
      data = await this._dataCacheService.set(COOKIES_CONFIG.SENSORS_DATA, res.patientList, res.expired)
    }
    this.sensorSource.next(data);
    return data;
  }

  /**
   * センサー登録
   * @param params
   */
  async create(params): Promise<any> {
    try {
      const res = await this.apiSleepSensorService.create(params);
      console.log({res});
      await this.fetch(true);
      this.createSource.next(res);
    } catch (e) {
      console.log({e});
      this.createSource.next(Observable.throw(e));
    }
  }

  /**
   * センサー一括登録
   */
  async createAll(paramsList: {
    makerCode: string;
    productCode: string;
    serialId: string;
    memo?: string;
  }[]): Promise<void> {
    try {
      const results = [];

      for (const params of paramsList) {
        try {
          const res = await this.apiSleepSensorService.create(params);
          console.log({res});
          results.push({
            serialId: params.serialId,
            status: 'success',
          });
        } catch (error) {
          results.push({
            serialId: params.serialId,
            status: 'error',
            error,
          });
        }
      }

      await this.fetch(true);
      this.createAllSource.next(results);
    } catch (e) {
      console.log({e});
      this.createAllSource.next(Observable.throw(e));
    }
  }

  /**
   * センサー情報をセットする
   * @param sensor
   */
  async update(params, options = { isFetch : true }): Promise<any> {
    try {
      const res = await this.apiSleepSensorService.update({ _id: params._id, body: params.body });
      this.setSource.next(res);
      if (options && options.isFetch) {
        await this.fetch(true);
      }
    } catch (e) {
      this.setSource.next(Observable.throw(e));
    }
  }

  /**
   * センサー情報全リセットする
   * @param sensor
   */
  async updateAll(params): Promise<any> {
    try {
      const res = await this.apiSleepSensorService.updateAll({ body: params.body });
      this.updateAllSource.next(res);
    } catch (e) {
      this.updateAllSource.next(Observable.throw(e));
    }
  }

    /**
   * センサー登録
   * @param params
   */
  async delete(params): Promise<any> {
    try {
      const res = await this.apiSleepSensorService.delete(params);
      await this.fetch(true);
      this.deleteSource.next(res);
    } catch (e) {
      console.log({e});
      this.deleteSource.next(Observable.throw(e));
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/sleep-sensor.service.ts